import { ServerUrls } from '~src/app/ServerUrls';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { ExplorableItemDefinition, SpaceDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ResourceGovernanceService } from '~src/schedule/types/ResourceGovernanceService';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ResourceGovernanceSettingContentType } from '~src/spacesPlatform/models/ContentTypes';

import { getNoDefaultFilters } from './getDefaultFilters';

export const ResourceGovernanceSettingDefiniton: ExplorableItemDefinition & SpaceDefinition<'resourceGovernanceSetting'> = {
  itemType: 'resourceGovernanceSetting',
  contentType: 'resourceGovernanceSetting',
  pluralName: Messages.resourceGovernanceSettingPlural,
  singularName: Messages.resourceGovernanceSettingSingular,
  emptyStateMessage: Messages.resourceGovernanceSettingEmptyMessage,
  contentFilterKeys: ResourceGovernanceSettingContentType.filterKeys,
  defaultFilters: getNoDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => {
    return ResourceGovernanceService.all();
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
  contentSpaceUrl: (_urls: SpacesSiteUrls, _contentId: string) => ServerUrls.getInstance().settingsResourceLimitsUrl(),
  headerIconPath: () => imgPath('spaces_masthead_schedule.svg'),
};
